var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatboxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.997,
    height: 17,
    viewBox: "0 0 16.997 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatboxes",
    "data-name": "Icon ionic-ios-chatboxes",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M22.3,11.981H13.243a1.559,1.559,0,0,0-1.557,1.557v6.306A1.556,1.556,0,0,0,13.243,21.4h5.182a.447.447,0,0,1,.311.131L21.311,23.9c.143.139.38.082.38-.119V21.716c0-.245.155-.323.4-.323h.041a1.7,1.7,0,0,0,1.721-1.553v-6.3A1.551,1.551,0,0,0,22.3,11.981Z",
    transform: "translate(-6.855 -6.979)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M8.541,7.376h7.25V4.707a1.333,1.333,0,0,0-1.332-1.332H4.707A1.333,1.333,0,0,0,3.375,4.707v6.752a1.333,1.333,0,0,0,1.332,1.332H7.2V8.708A1.339,1.339,0,0,1,8.541,7.376Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatboxes);
export default __webpack_public_path__ + "static/media/chatboxes.1c7f2a2b77895976f5a35e3bec70b4c3.svg";
export { ForwardRef as ReactComponent };